(function() {
    'use strict';

    angular
        .module('receiptApp', ['corePRUGAGreatApp', 'updateClientApp'])
        .run(run);

    run.$inject = ['stateHandler'];

    function run(stateHandler) {
        stateHandler.initialize();
    }

})();
